module.exports = __webpack_public_path__ + "d7b5e2d87ae0ab80c0a5a9e907fb962e.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/intro-panel-texture-1024.webp.png
// module id = 406
// module chunks = 0